'use client';

import { useSubscription } from '../hooks/useSubscription';
import { BillingPortalButton } from './BillingPortalButton';

const TIER_LABEL: Record<string, string> = {
  free: 'Free',
  starter: 'Core',
  pro: 'Pro',
  elite: 'Elite',
};

const STATUS_LABEL: Record<string, string> = {
  active: 'Active',
  trialing: 'Trial',
  past_due: 'Payment overdue',
  canceled: 'Canceled',
  incomplete: 'Setup incomplete',
};

export function SubscriptionStatus() {
  const { data, isLoading } = useSubscription();
  if (isLoading || !data) {
    return <div className="text-sm text-muted-foreground">Loading…</div>;
  }

  const tierLabel = TIER_LABEL[data.tier] ?? data.tier;
  const statusLabel = STATUS_LABEL[data.status] ?? data.status;
  const periodEnd = data.current_period_end
    ? new Date(data.current_period_end).toLocaleDateString()
    : null;

  return (
    <div className="flex items-start justify-between rounded-lg border border-border p-4">
      <div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground">
          Current plan
        </div>
        <div className="mt-1 flex items-baseline gap-2">
          <span className="font-serif text-2xl">{tierLabel}</span>
          <span className="text-xs text-muted-foreground">{statusLabel}</span>
        </div>
        {data.billing_interval && (
          <div className="mt-1 text-xs text-muted-foreground">
            {data.billing_interval === 'monthly' ? 'Monthly' : 'Annual'}
            {data.amount_usd && ` · $${data.amount_usd}`}
            {data.provider && ` · via ${data.provider === 'stripe' ? 'card' : 'crypto'}`}
          </div>
        )}
        {periodEnd && (
          <div className="mt-2 text-xs text-muted-foreground">
            {data.cancel_at_period_end ? 'Ends' : 'Renews'} {periodEnd}
          </div>
        )}
      </div>
      {data.provider === 'stripe' && <BillingPortalButton />}
    </div>
  );
}
